import styled from '@emotion/styled'
import { Input } from 'ui-components/Input'

export const InputForm = styled(Input)`
  margin-bottom: 20px;
`
